import { render } from "./PDFUploader.vue?vue&type=template&id=2907f5f2&scoped=true&ts=true"
import script from "./PDFUploader.vue?vue&type=script&lang=ts"
export * from "./PDFUploader.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2907f5f2"]])

export default __exports__